import { matchPath } from 'react-router-dom';
import * as constants from 'app-constants';
import _get from 'lodash/get';

export default {
  getAppIdFromPath(locationPath) {
    let targetPath = locationPath;

    if (!targetPath) {
      [, targetPath] = window.location.pathname.split(constants.PATH_BASE);
    }

    const match = matchPath(targetPath, {
      path: constants.PATH_SEARCH_APPID
    });

    return _get(match, 'params.appId');
  },

  getFeaturesListPathParams(locationPath = '') {
    const match = matchPath(locationPath, {
      path: constants.PATH_FEATURES_LIST
    });
    return match && match.params;
  },

  isFeaturePath(locationPath = '') {
    const match = matchPath(locationPath, {
      path: constants.PATH_FEATURES,
      exact: true,
      strict: false
    });

    return (
      match &&
      match.params &&
      Object.keys(match.params).length === 1 &&
      match.params.appId
    );
  },

  /*
  isApplicationsPath(locationPath = '') {
    let targetPath = locationPath;

    if (!targetPath) {
      [, targetPath] = window.location.pathname.split(constants.PATH_BASE);
    }

    const match = matchPath(targetPath, {
      path: constants.PATH_APPLICATIONS,
      exact: true,
      strict: false
    });

    return match;
  },
  */

  getEnvFromPath: (locationPath) => {
    let targetPath = locationPath;
    let envName;

    if (!targetPath) {
      [, targetPath] = window.location.pathname.split(constants.PATH_BASE);
    }

    constants.PATH_WITH_ENV.find((path) => {
      const match = matchPath(targetPath, {
        path,
        exact: true,
        strict: false
      });
      if (match && match.params.env) {
        ({ env: envName } = match.params);
        return true;
      }
      return false;
    });

    return envName;
  }
};
